export default "__VITE_ASSET__8186a975__"